import { render, staticRenderFns } from "./formattedDueDate.vue?vue&type=template&id=1a113bfe"
import script from "./formattedDueDate.vue?vue&type=script&lang=js"
export * from "./formattedDueDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports